/*!
 *  (c)(r) 2008-2021 IT-Service Robert Frunzke
 */

import { sprintf } from '../../vendor/sprintf.js';
import { sprintf_0xd, sprintf_0x3 } from '../../manja/sprintf-util.js';
import { MDLocaleBase } from '../../manja/locale-base.js';


let MDLocale_de_DE = function(window) {

	var decimal_point_char = ',';

	var m_monthNames = ['Januar','Februar','März','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember'];


	function fmt_duration( s, with_ms, roundLastUnit ) {
		var t = '', x, min, ms,
			roundFn = roundLastUnit ? Math.round : Math.floor;
		if( s >= 86400 ) {
			// days
			x = Math.floor(s/86400);
			s -= x*86400;
			t += x+'d';
		}
		if( t.length || s >= 3600 ) {
			// hours
			x = Math.floor(s/3600);
			s -= x*3600;
			t += x+':';
		}
		// mm:ss
		min = Math.floor(s/60);
		if( with_ms ) {
			// mm:ss.xxx (xxx=ms)
			ms = roundFn(1000*(s%60));
			t += sprintf( '%02d:%02d.%03d', min, Math.floor(ms/1000), ms%1000 );
		} else {
			// mm:ss
			t += sprintf( '%02d:%02d', min, roundFn(s%60) );
		}
		return t.length ? t : '00:00';
	}

	function fmt_duration_fancy( s, plain_text, granularity ) {
		if( typeof(granularity)==='undefined' ) granularity = 2;
		var units = [
			[ '1 Jahr',    ' Jahre',   31536000 ],
			[ '1 Monat',   ' Monate',   2592000 ],
			[ '1 Woche',   ' Wochen',    604800 ],
			[ '1 Tag',     ' Tage',       86400 ],
			[ '1 h',       ' h',           3600 ],
			[ '1 min',     ' min',           60 ],
			[ '1 s',       ' s',              1 ],
		];
		var out = [],
			iv = s,
			i, l, u, x, p;
		for( i=0, l=units.length; i<l; ++i ) {
			u = units[i];
			if( iv > u[2] ) {
				x = Math.floor(iv/u[2]);
				iv = iv % u[2];
				p = x===1 ? (u[0]) : (x+u[1]);
				if( !plain_text ) p = p.replace(' ',MDLocaleBase.real_thinspace_x);
				out.push( p );
				if( --granularity <= 0 ) break;
			}
		}
		if( out.length ) return out.join(' ');
		out = ('0'+units[units.length-1][1]);
		return plain_text ? out : out.replace(' ',MDLocaleBase.real_thinspace_x);
	}

	function fmt_number( n, type, plain_text ) {
		var decimals = 5;
		if( type === 'filesize' ) return MDLocaleBase.fmt_filesize(n,plain_text);
		else if( type === 'degree' ) return fmt_number(n) + (plain_text?'':MDLocaleBase.real_thinspace_x) + '°';
		else if( type === 'duration' ) return plain_text ? fmt_duration(n,false) : '<span title="'+fmt_duration(n,true)+' / '+n+'s">'+fmt_duration(n,false)+'</span>';
		else if( plain_text ) return fmt_float_plain(n,decimals,false);

		if( typeof n !== 'number' ) n = parseFloat(n).toFixed(decimals);
		else n = n.toFixed(decimals);
		var a = parseInt(n,10),
			f = n-a, // 100.3-100=0.3;   -100.3+100=-0.3
			sign = '',
			str = [],
			m;
		if( a < 0 || Object.is(a,-0) ) {
			sign = '-';
			a = -a;
			f = -f;
		}
		do {
			m = a % 1000;
			a = ( a / 1000 ) | 0;
			str[str.length] = a===0 ? m.toString() : ( '<span style="margin-left:0.125em">' + sprintf_0x3(m) + '</span>' );
		} while( a > 0 );
		str.reverse();
		f = sprintf_0xd(parseInt(Math.round(f*Math.pow(10,decimals)),10),decimals);
		while( f.length && f.charAt(f.length-1)==='0' ) f = f.substr(0,f.length-1);
		return sign + str.join('') + ( f==='' ? '' : ( decimal_point_char + f ) );
	}

	function fmt_float_plain( n, decimals, fill_decimals ) {
		if( typeof n !== 'number' ) n = parseFloat(n).toFixed(decimals);
		else n = n.toFixed(decimals);
		var a = parseInt(n,10),
			f = n-a, // 100.3-100=0.3;   -100.3+100=-0.3
			sign = '',
			str = [],
			m;
		if( a < 0 || Object.is(a,-0) ) {
			sign = '-';
			a = -a;
			f = -f;
		}
		do {
			m = a % 1000;
			a = ( a / 1000 ) | 0;
			str[str.length] = a===0 ? m.toString() : sprintf_0x3(m);
		} while( a > 0 );
		str.reverse();
		f = sprintf_0xd(parseInt(Math.round(f*Math.pow(10,decimals)),10),decimals);
		if( !fill_decimals ) {
			while( f.length && f.charAt(f.length-1)==='0' ) f = f.substr(0,f.length-1);
		}
		return sign + str.join('') + ( f==='' ? '' : ( decimal_point_char + f ) );
	}

	function fmt_number_input( n ) {
		return n.toString().replace( /\./g, decimal_point_char );
	}
	function xtr_number_input( n ) {
		return n.toString().replace( /\./g, '' ).replace( /,/g, '.' );
	}


	function fmt_datetime( d ) {
		var sd = fmt_date(d),
			st = fmt_time(d);
		if( st==='' || st==='00:00' ) return sd;
		return sd + ', ' + st;// + ' Uhr';
	}
	function fmt_datetime_detailed( d ) {
		var sd = fmt_date(d),
			st = fmt_time_detailed(d);
		return st==='' ? sd : (sd+', '+st);
	}

	function fmt_date( d ) {
		if( d===null || d.length===0 ) return '';
		return d.substr(8,2) + '.' + d.substr(5,2) + '.' + d.substr(0,4);
	}
	function fmt_date_ym( d ) {
		if( d===null || d.length===0 ) return '';
		return m_monthNames[parseInt(d.substr(5,2),10)-1] + ' ' + d.substr(0,4);
	}

	function fmt_time( d ) {
		if( d===null || d.length===0 ) return '';
		var offs = d.length >= 10 ? 11 : 0, // datetime or time-only
			s = d.substr(offs,2) + ':' + d.substr(offs+3,2),
			sec = d.substr(offs+6,2)
			;
		if( sec === '' || sec === '00' ) return s===':' ? '' : s;
		return s + ':' + sec;
	}
	function fmt_time_detailed( d ) {
		if( d.length < 19 ) return '';
		return d.substr(11,2) + ':' + d.substr(11+3,2) + ':' + d.substr(11+6,2);
	}

	function xtr_datetime( sd, st ) {
		var d = xtr_date(sd);
		if( d !== '' ) {
			var t = xtr_time(st);
			if( t === '' ) t = '00:00:00'; // set to midnight
			d += ' ' + t;
		}
		return d;
	}
	function xtr_date( s ) {
		if( !s.match(/^\d\d\.\d\d\.\d\d\d\d$/) ) return '';
		return s.substr(6,4) + '-' + s.substr(3,2) + '-' + s.substr(0,2);
	}
	function xtr_time( s ) {
		if( s.match(/^\d\d:\d\d:\d\d$/) ) return s;
		else if( s.match(/^\d\d:\d\d$/) ) return s+':00';
		else if( s.match(/^\d\d$/) ) return s+':00:00';
		return '';
	}

	var localized_string_compare = function( a, b ) {
		return a.localeCompare(b,'de-DE',{ignorePunctuation:true});
	};
	try {
		'foo'.localeCompare('bar','de-DE',{ignorePunctuation:true});
	} catch( err ) {
		localized_string_compare = function( a, b ) {
			return a.localeCompare(b);
		};
	}


	return Object.assign( {}, MDLocaleBase, {

		fmt_duration: fmt_duration,
		fmt_duration_fancy: fmt_duration_fancy,
		fmt_number: fmt_number,
		fmt_float_plain: fmt_float_plain,
		fmt_number_input: fmt_number_input,
		xtr_number_input: xtr_number_input,
		fmt_datetime: fmt_datetime,
		fmt_datetime_detailed: fmt_datetime_detailed,
		fmt_date: fmt_date,
		fmt_date_ym: fmt_date_ym,
		fmt_time: fmt_time,
		fmt_time_detailed: fmt_time_detailed,
		xtr_datetime: xtr_datetime,
		xtr_date: xtr_date,
		xtr_time: xtr_time,
		localized_string_compare: localized_string_compare,

		decimal_point_char: decimal_point_char,

		get_locale: function() {
			return 'de_DE';
		},

		initWithJQuery: function( $ ) {
			/* German initialisation for the jQuery UI date picker plugin. */
			if( $ && $.datepicker ) {
				/* Written by Milian Wolff (mail@milianw.de). */
				$.datepicker.regional['de'] = {
					closeText: 'schließen',
					prevText: '&#x3c;zurück',
					nextText: 'Vor&#x3e;',
					currentText: 'heute',
					monthNames: m_monthNames,
					monthNamesShort: ['Jan','Feb','Mär','Apr','Mai','Jun','Jul','Aug','Sep','Okt','Nov','Dez'],
					dayNames: ['Sonntag','Montag','Dienstag','Mittwoch','Donnerstag','Freitag','Samstag'],
					dayNamesShort: ['So','Mo','Di','Mi','Do','Fr','Sa'],
					dayNamesMin: ['So','Mo','Di','Mi','Do','Fr','Sa'],
					weekHeader: 'Wo',
					dateFormat: 'dd.mm.yy',
					firstDay: 1,
					isRTL: false,
					showMonthAfterYear: false,
					yearSuffix: ''};
				$.datepicker.setDefaults($.datepicker.regional['de']);
			}
			// select2 i18n
			if( $ && $.fn.select2 ) {
				$.fn.select2.defaults.set('language',{
					errorLoading:function() {
						return "Ergebnisse konnten nicht geladen werden.";
					},
					inputTooLong:function(e) {
						var t=e.input.length-e.maximum; return "Bitte "+t+" Zeichen weniger eingeben";
					},
					inputTooShort:function(e) {
						var t=e.minimum-e.input.length; return "Bitte "+t+" Zeichen mehr eingeben";
					},
					loadingMore:function() {
						return "Lade mehr Ergebnisse…";
					},
					maximumSelected:function(e) {
						var t="Sie können nur "+e.maximum+" Eintr"; return e.maximum===1?t+="ag":t+="äge",t+=" auswählen",t;
					},
					noResults:function() {
						return "Keine Übereinstimmungen gefunden";
					},
					searching:function(e) {
						window._mj_cur_select2_query=e; return "Suche…";
					},
				});
			}
		}
	} );

}(window); // namespace MDLocale_de_DE

MDLocaleBase.init_with_impl(MDLocale_de_DE);

export default MDLocale_de_DE;
